<template>
  <div class="policy">
        <div class="policy-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            v-model="pageVO.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <div class="selectType" v-if="activeName !== 1">
            <span>类型：</span>
            <el-select
              v-model="type"
              placeholder="请选择"
              clearable
              @change="selectType"
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @selection-change="tabSelect"
            :header-cell-style="headerStyle"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (pageVO.page - 1) * pageVO.pageSize + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="policyDateTime"
              label="时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="publish"
              label="是否发布"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.publish == 2"
                  >已发布</el-tag
                >
                <el-tag type="info" v-else>未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- <el-button-group> -->
                <el-button size="mini" @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="preview(scope.row)"
                  v-if="scope.row.publish == 1"
                  >确定发布</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="preview(scope.row)"
                  v-else
                  >取消发布</el-button
                >
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageVO.page"
          :page-size="pageVO.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
    <!--    <el-tabs v-model="activeName">
      <el-tab-pane label="国家级政策" name="1"></el-tab-pane>
      <el-tab-pane label="省级政策" name="2"></el-tab-pane>
      <el-tab-pane label="市级政策" name="3"></el-tab-pane>
      <el-tab-pane label="政策解读" name="4"></el-tab-pane>
    </el-tabs>-->

    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @closed="is_submit = true"
    >
      <el-form
        v-if="dialogFormVisible"
        :model="ruleForm"
        ref="ruleForm"
        label-width="105px"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title" clearable></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitle">
          <el-input v-model="ruleForm.subtitle" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="policyDateTime">
          <el-date-picker
            v-model="ruleForm.policyDateTime"
            :picker-options="pickerOptions"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="text-align: left; width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属年度" prop="belongYear">
          <el-date-picker
            v-model="ruleForm.belongYear"
            :picker-options="pickerOptions"
            type="year"
            placeholder="选择年度"
            format="yyyy"
            value-format="yyyy"
            style="text-align: left; width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="政策信息" prop="content">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
            v-model="ruleForm.content"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
        <el-form-item label="发布:" prop="publish" style="text-align: left">
          <el-col :span="12">
            <el-switch
              v-model="ruleForm.publish"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :active-value="2"
              :inactive-value="1"
            ></el-switch>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from "../../../components/tinymce-editor/tinymce-editor";
import CommonLayout from "../../../components/common-layout.vue";
import { DisabledDateFn } from "../../../utils/tool";
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      show: false,
      type: "",
      activeName: 1,
      selected: [],
      total: 0,
      pageVO:{
        keyword:null,
        page:1,
        pageSize:10
      },
      dialogFormVisible: false,
      Title: "",
      tableData: [],
      ruleForm: {
        title: "",
        subtitle: "",
        policyDateTime: "",
        content: "",
        belongYear: "",
      },
      options: [
        {
          value: 1,
          label: "科技口",
        },
        {
          value: 2,
          label: "工信口",
        },
        {
          value: 3,
          label: "发改口",
        },
        {
          value: 4,
          label: "人社口",
        },
        {
          value: 5,
          label: "其他口",
        },
      ],
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        policyDateTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        belongYear: [
          {
            required: true,
            message: "请选择年度",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getDate("Policy?category_first=" + this.activeName);
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getDate(url) {
      this.http.post(this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-policy-info/page',this.pageVO).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          
          // if (this.tableData[0].category_second) {
          //   this.show = true;
          // } else {
          //   this.show = false;
          // }
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
    //新增
    add() {
      this.Title = "新建";
      this.dialogFormVisible = true;
      this.ruleForm = {
        title: "",
        subtitle: "",
        policyDateTime: "",
        content: "",
        belongYear: "",
      };
    },
    //编辑
    handleEdit(val) {
      this.Title = "编辑";
      this.dialogFormVisible = true;
      // this.http.get("Policy/" + val.id).then((res) => {
      //   if (res.code == 0) {
          this.ruleForm = val;
      //     console.log("s数据结果", this.ruleForm);
      //   }
      // });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          if (!obj.id) {
            this.http.post(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-policy-info/create", obj).then((res) => {
              if (res.code == 0) {
                // this.ResetSearch(["searchValue", "type"]);

                this.$message.success("新建成功");
                this.getDate();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.publish);
              }
            });
          } else {
            this.http.put(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-policy-info/update", obj).then((res) => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.getDate();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.publish);
              }
            });
          }
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //发布
    preview(e) {
      let data = e;
      if (e.publish == 1) {
        data.publish = 2;
      } else if (e.publish == 2) {
        data.publish = 1;
      }
      this.http.put(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-policy-info/update", data).then((res) => {
      // this.http.put("Policy/" + e.id, data).then((res) => {
        if (res.code == 0) {
          if (data.publish == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.success("已取消发布");
          }
          this.getDate("Policy?category_first=" + this.activeName);
        }
      });
    },
    //搜索
    search() {
      this.pageVO.page =1
      this.pageVO.pageSize =10
      this.getDate();
    },
    selectType(e) {
      this.getDate();
    },
    //删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http.request(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-policy-info/delete", {
            ids:[row.id]
          }, "delete").then((res) => {
          // this.http.request(this.urlConfig.devUrl+"/apij2/admin-api/voucher/incubation-policy-info/delete", "", "delete").then((res) => {
            if (res.code == 0) {
              this.pageVO.page = 1
              this.getDate();
              this.searchValue = "";
              this.type = "";
              this.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              this.$message({
                message: "失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.selected.length >0) {
        this.$confirm("确定删除文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(this.urlConfig.devUrl+"apij2/admin-api/voucher/incubation-policy-info/delete", {ids:this.selected}, "delete")
              .then((response) => {
                if (response.code == 0) {
                  this.pageVO.page = 1
                  this.$message.success("删除成功！");
                  this.getDate();
                  this.searchValue = "";
                  this.type = "";
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的文件",
        });
      }
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //翻页
    handleCurrentChange(val) {
      this.pageVO.page = val;
      this.getDate();
    },
    //选择行数
    tabSelect(sec) {
      let ids = [];
      for (let i of sec) {
        ids.push(i.id)
      }
      // ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    // 切换tab
    handleClick(val) {
      this.activeName = val;
      this.searchValue = "";
      this.type = "";
      this.getDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  height: 100%;

  .policy-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  .policy_tabs {
    width: 600px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }

  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: "/";
        }
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
</style>
